<span  class="loading-dots">
  <span [style.height]="size||'inherit'" [style.width]="size||'inherit'" class="loading-dot"></span>
  <span [style.height]="size||'inherit'" [style.width]="size||'inherit'"  class="loading-dot"></span>
  <span [style.height]="size||'inherit'" [style.width]="size||'inherit'"  class="loading-dot"></span>
</span>
